import * as React from 'react'
import * as styles from '../Hover.module.scss'
import * as cn from 'classnames'
import { UpdateableHoverProps } from '../Hover'
import { ReviewsRating } from './ReviewsRating'
import { Icon, IconType } from '@amzn/dvui/dist/Icon'
import { Text } from '@amzn/dvui/dist/Text'
import { MaturityRating } from '@amzn/dvui/dist/MaturityRating'

export const ExtraMetadata = (props: UpdateableHoverProps) =>
    (<>
        {props.liveInfo && props.liveInfo.timeBadge &&
            <div className={styles.extraMetadata}>
                <span className={cn(styles.tailContent, styles.tailText)}>
                    {props.liveInfo.timeBadge}
                </span>
            </div>}
        <div className={styles.extraMetadata}>
            {props.liveInfo && props.liveInfo.venue &&
                <div className={cn(styles.tailContent, styles.tailText)}>
                    {props.liveInfo.venue}
                </div>}
            {props.customerReviews &&
                <div className={styles.tailContent}>
                    <ReviewsRating
                        rating={props.customerReviews.value}
                        link={props.customerReviews.link} />
                </div>}
            {props.imdbRating &&
                <div className={cn(styles.tailContent, styles.tailText)}>
                    IMDb {props.imdbRating}
                </div>}
            {props.runtime &&
                <div className={cn(styles.tailContent, styles.tailText)}>
                    {props.runtime}
                </div>}
            {props.releaseYear &&
                <div className={cn(styles.tailContent, styles.tailText)}>
                    {props.releaseYear}
                </div>}
            {props.hasSubtitles &&
                <div className={cn(styles.tailContent, styles.alignMiddle)} >
                    <Icon use={IconType.SUBTITLES} className={'tst-hover-subtitles'} />
                </div>}
            {props.contentMaturityRating &&
                <div className={cn(styles.tailContent)}>
                    <MaturityRating {...props.contentMaturityRating}
                        className={'tst-hover-maturity-rating'}>
                        {props.contentMaturityRating.link &&
                            <Text>{props.contentMaturityRating.link}</Text>}
                    </MaturityRating>
                </div>}
        </div>
    </>)